import { useEffect } from 'react';

export const SITE_URL = 'https://revoltdigital.me';
export const SITE_NAME = 'Elina K. Photography';
export const DEFAULT_IMAGE = 'https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/684vzkny_IMG_4729.webp';

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [key, val] = selector.replace('meta[', '').replace(']', '').split('=');
    el.setAttribute(key, val.replace(/"/g, ''));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const usePageMeta = ({ title, description, path = '/', image = DEFAULT_IMAGE }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} – Family, Newborn, Maternity & Couples Photographer in Dubai`;
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [title, description, path, image]);
};
